var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from "lodash";
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var PostControllerTube = /** @class */ (function () {
    function PostControllerTube() {
    }
    /*****************************************************************************************************
        * Is using route "api/post/TubePost/neighbors" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<TubePostDownloadDto, string>}
    ******************************************************************************************************/
    PostControllerTube.GetNeighbors = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("id", JSON.stringify(data.id));
        fd.append("token", JSON.stringify(data.token));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/TubePost/neighbors", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/TubePost/{lng}/trie" and http method "GET" to call the back-end.
    
        * @param {string} lng
        * @returns {ExtendedDataCollection<TubePostDownloadDto, Node<string>>}
    ******************************************************************************************************/
    PostControllerTube.GetTubePostsWithTire = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/TubePost/{lng}/trie", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/TubePost/views" and http method "POST" to call the back-end.
    
        * @param {string[]} postIds
        * @returns {ViewStats[]}
    ******************************************************************************************************/
    PostControllerTube.GetPostsViews = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("postIds", JSON.stringify(data.postIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/TubePost/views", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/TubePost/subtitles/{id}/{lng}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} lng
        * @param {TubePostUploadDto} postDto
        * @param {{[key: string]: File}} subtitle
        * @returns {TubePostDownloadDto}
    ******************************************************************************************************/
    PostControllerTube.PatchSubTitles = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("postDto", JSON.stringify(data.postDto));
        _.forEach(data.subtitle, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/TubePost/subtitles/{id}/{lng}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/TubePost" and http method "POST" to call the back-end.
    
        * @param {{[key: string]: File}} thumbnail
        * @param {TubePostUploadDto} data
        * @param {{[key: string]: File}} content
        * @returns {TubePostDownloadDto}
    ******************************************************************************************************/
    PostControllerTube.PostTubePost = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        _.forEach(data.thumbnail, function (val, key) { return fd.append(key, val); });
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.content, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/TubePost", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/TubePost/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {{[key: string]: File}} thumbnail
        * @param {TubePostUploadDto} data
        * @param {{[key: string]: File}} content
        * @returns {TubePostDownloadDto}
    ******************************************************************************************************/
    PostControllerTube.PatchTubePost = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        _.forEach(data.thumbnail, function (val, key) { return fd.append(key, val); });
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.content, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/TubePost/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/tube/getUploadUrl" and http method "POST" to call the back-end.
    
        * @param {string} mediaType
        * @param {string} fileName
        * @returns {UploadMediaParametersDto}
    ******************************************************************************************************/
    PostControllerTube.GetUploadUri = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.mediaType !== undefined)
            fd.append("mediaType", JSON.stringify(data.mediaType));
        if (data.fileName !== undefined)
            fd.append("fileName", JSON.stringify(data.fileName));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/tube/getUploadUrl", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    return PostControllerTube;
}());
export { PostControllerTube };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=PostControllerTube.js.map